import { render } from "./LoginRecover.vue?vue&type=template&id=56a98d54&scoped=true"
import script from "./LoginRecover.vue?vue&type=script&lang=js"
export * from "./LoginRecover.vue?vue&type=script&lang=js"

import "./LoginRecover.vue?vue&type=style&index=0&id=56a98d54&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a98d54"]])

export default __exports__